import React, { Fragment, Suspense, useEffect } from "react";
import { BrowserRouter,  Route, Routes, useNavigate } from "react-router-dom";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoute from "./PrivateRoute";
import { ToastContainer } from "react-toastify";
import Login from "../Pages/Authentication/Login";
import ForgotPassword from "../Pages/Authentication/ForgotPassword";
import { navigateToFirstModule } from "../Constant/common";

const Routers = () => {
  const RedirectToFirstModule = () => {
    const navigate = useNavigate();

    useEffect(() => {
      navigateToFirstModule(navigate);
    }, [navigate]);

    return null;
  };
  return (
    <Fragment>
      <BrowserRouter basename={"/"}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Suspense>
          <Routes>
            <Route path={"/"} element={<PrivateRoute />}>
              <Route exact path="/" element={<RedirectToFirstModule />} />
              <Route path="/*" element={<LayoutRoutes />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Fragment>
  );
};
export default Routers;
